var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgDrawnArrow = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 69,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#1F9DA3",
  d: "M20.294 2.039a1.5 1.5 0 1 0-2.92.688zM2.012 66.8a1.5 1.5 0 0 0 1.673 1.304l13.397-1.657a1.5 1.5 0 1 0-.368-2.978l-11.91 1.474-1.473-11.91a1.5 1.5 0 1 0-2.977.369zM17.374 2.727c3.398 14.412 3.222 25.483.454 35.232-2.775 9.771-8.191 18.349-15.51 27.735l2.365 1.845c7.406-9.497 13.1-18.437 16.03-28.76 2.94-10.348 3.068-21.952-.42-36.74l-2.92.688z"
})));
export default SvgDrawnArrow;